import React from 'react';

// Minimal Phone Widget with customizable length and digit-only option
const PhoneWidget = props => {
  // eslint-disable-next-line react/prop-types
  const { value, onChange, placeholder, disabled, readonly, options = {} } = props;
  const { length = 10, digitsOnly = true } = options;

  const handleChange = event => {
    let inputValue = event.target.value;

    if (digitsOnly) {
      // Remove all non-digit characters
      inputValue = inputValue.replace(/\D/g, '');
    }

    // Limit to specified length
    if (inputValue.length > length) {
      inputValue = inputValue.slice(0, length);
    }

    onChange(inputValue);
  };

  return (
    <input
      type="tel"
      className="form-control"
      value={value || ''}
      placeholder={placeholder || `Enter ${length}-digit phone number`}
      onChange={handleChange}
      disabled={disabled}
      readOnly={readonly}
      maxLength={length}
      pattern={digitsOnly ? '[0-9]*' : undefined}
      inputMode={digitsOnly ? 'numeric' : 'tel'}
      title={`Enter a ${length}-character phone number${digitsOnly ? ' (digits only)' : ''}`}
    />
  );
};

export default PhoneWidget;
